import vueWrapper from "../../utils/vue-wrapper"
import miniCart from './mini-cart.vue';
import cartStore from './store'

export default () => {
  vueWrapper(miniCart, "vue-mini-cart", "#cartData",cartStore)
}